import { SKELETON_RIPPLE_DURATION as e } from "../../lib/skeleton/skeleton-constants.js";
//#region common/mixins/skeleton.js
var t = { computed: {
	skeletonOffset() {
		let e = this.$refs.skeleton;
		if (!e) return this.offset;
		let { top: t, height: n } = e.getBoundingClientRect();
		return t + n / 2;
	},
	skeletonStyle() {
		let t = {};
		if (this.skeletonOffset === -1 || !this.animate && this.animationDuration === -1) return t;
		let n = this.skeletonOffset * e / 1e3, r = this.animationDuration === -1 ? 1e3 : this.animationDuration;
		return t.animationDelay = `${n}ms`, t.animationDuration = `${r}ms`, t;
	}
} };
//#endregion
export { t as default };

//# sourceMappingURL=skeleton.js.map